module.exports = __webpack_public_path__ + "img/nlmfy.edcdbefe.jpg";